// Returns [item] when the condition is truthy, otherwise an empty array.
// Useful for conditionally spreading a single entry into an array literal
// without nesting ternaries (`...includeIf(cond, item)`).
export const includeIf = <T>(condition: boolean, item: T): T[] =>
  condition ? [item] : [];

// Find values that don't intersect between arrays and are unique
export const findIntersectionLeftovers = <T = string>(
  arr1: T[],
  arr2: T[]
): T[] => {
  const set1 = new Set(arr1);
  const set2 = new Set(arr2);

  const uniqueInArr1 = arr1.filter((item) => !set2.has(item));
  const uniqueInArr2 = arr2.filter((item) => !set1.has(item));

  return Array.from(new Set([...uniqueInArr1, ...uniqueInArr2]));
};
